import React, { useState } from 'react'
import Video from '../../videos/video.mp4'
import Video2 from '../../videos/video.mp4'
import { Button } from '../ButttonElement'
import {
  HeroBg,
  HeroContainer,
  VideoBg,
  HeroContent,
  HeroH1,
  HeroP,
  HeroBtnWrapper,
  ArrowForward,
  ArrowRight,
} from './HeroElements'

function HeroSection() {
  const [hover, setHover] = useState(false)

  const onHover = () => {
    setHover(!hover)
  }
  return (
    <HeroContainer>
      <HeroBg>
        <VideoBg autoPlay loop muted src={Video} type='video/mp4'></VideoBg>
      </HeroBg>
      <HeroContent>
        <HeroH1>Meet CloudSicher</HeroH1>
        <HeroP>
          We shape your business! <br></br>
          Digital technologies are disrupting old industries and creating new
          ones. This brings lots of opportunities, We help you by arranging the
          right TECH-resources, IT consultation, Infrastructure/Cloud solutions
          and solfware/web solutions.{' '}
        </HeroP>
        <HeroBtnWrapper>
          <Button
            to='/services'
            onMouseEnter={onHover}
            onMouseLeave={onHover}
            primary='true'
            dark='true'
          >
            Read More{hover ? <ArrowForward /> : <ArrowRight />}
          </Button>
        </HeroBtnWrapper>
      </HeroContent>
    </HeroContainer>
  )
}

export default HeroSection
